import {GET_BALANCE} from '../types';
import axios from 'axios';
import {domain, naturalUrlAttr} from "../../config";

export const getBalance = () => async dispatch => {
    try {
        let response = await axios.get(`${domain}account/balance?${naturalUrlAttr}`);

        dispatch({
            type: GET_BALANCE,
            payload: response.data
        });
    } catch (e) {
        console.log('Error balance');
    }
};
